import { Box, Grid } from "@mui/material";
import { Editor } from "@hugerte/hugerte-react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import BaseLabel from "components/BaseLabel";
import { EditorContainer } from "./styles";

interface ExternalLinkTextEmailProps {
  setEditedValue: (value: string) => void;
  editedValue: string;
  fieldError: boolean;
}

const ExternalLinkTextEmail = ({
  setEditedValue,
  editedValue,
  fieldError,
}: ExternalLinkTextEmailProps) => {
  const { t } = useTranslation();
  const editorRef = useRef<any>(null);

  const editorConfig = {
    height: 400,
    menubar: false,
    branding: false,
    resize: false,
    plugins: [
      "advlist",
      "autolink",
      "lists",
      "link",
      "charmap",
      "code",
      "insertdatetime",
      "table",
      "wordcount",
    ],
    toolbar:
      "undo redo | blocks | " +
      "bold italic forecolor backcolor | alignleft aligncenter " +
      "alignright alignjustify | bullist numlist outdent indent | " +
      "link table | code | removeformat",
    content_style:
      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
    placeholder: t("systemConfiguration.externalLinkEmail.placeholder"),
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <BaseLabel
          fontSize="18px"
          fontWeight="700"
          marginBottom="8px"
          marginTop="0px"
          marginLeft="0px"
          marginRight="0px"
        >
          {t("systemConfiguration.externalLinkEmail.title")}
        </BaseLabel>
      </Grid>
      <Grid item xs={12}>
        <EditorContainer error={fieldError}>
          <Editor
            ref={editorRef}
            inline={false}
            onEditorChange={(content) => setEditedValue(content)}
            value={editedValue}
            onInit={(editor) => (editorRef.current = editor)}
            init={editorConfig}
          />
        </EditorContainer>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            color: "#666",
            marginTop: "8px",
            "& code": {
              backgroundColor: "#f4f4f4",
              padding: "2px 6px",
              borderRadius: "3px",
              fontFamily: "monospace",
              fontSize: "13px",
            },
          }}
        >
          <strong>{t("systemConfiguration.externalLinkEmail.availableVariables")}</strong>
          <br />
          • <code>{"{title}"}</code> - {t("systemConfiguration.externalLinkEmail.varTitle")}
          <br />
          • <code>{"{customText}"}</code> - {t("systemConfiguration.externalLinkEmail.varCustomText")}
          <br />
          • <code>{"{link}"}</code> - {t("systemConfiguration.externalLinkEmail.varLink")}
          <br />
          • <code>{"{expireDate}"}</code> - {t("systemConfiguration.externalLinkEmail.varExpireDate")}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ExternalLinkTextEmail;
